import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=37a5074d&scoped=true&"
import script from "./ComponentList.vue?vue&type=script&lang=js&"
export * from "./ComponentList.vue?vue&type=script&lang=js&"
import style0 from "./ComponentList.vue?vue&type=style&index=0&id=37a5074d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5074d",
  null
  
)

export default component.exports